<!--
     <ProcessDependingUserField
       :props="my_attrs_dictionary"
       @bind="my_bind_handler"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - id [REQUIRED] → This instance id.
     - process_field_id [REQUIRED] → The id of a process select to watch
     - permission_id [REQUIRED] → The permission_id, like "NCDEFAULT.evaluador"
     - multiple (default: false)
     - value
     - label
     - placeholder
-->

<template>
  <v-select
    v-model="props.value"
    :items="items"
    :label="props.label"
    :placeholder="props.placeholder"
    :multiple="props.multiple"
    :loading="loading"
    item-value="0"
    item-text="1"
    :rules="rules"
    :class="[props.class || 'qmkey-form-input', {'required':props.required}]"
    outlined
    dense
    :readonly="!!props.readonly"
    :disabled="!!props.disabled || !!props.readonly"
    @change="update"
  >
    <template>
      <v-icon slot="append" color="primary" v-if="!props.disabled && !props.readonly">
        {{ false || "mdi-menu-down" }}
      </v-icon>
      <div v-else slot="append"></div> <!-- Hide icon -->
    </template>
  </v-select>
</template>


<script>
import { mapGetters } from 'vuex'
import QUnitWidgets from '@/api/QUnitWidgets'

export default {
  name: 'DynamicSelectInput',

  props: ['props','form_values','current_unit'],

  data: () => ({
    items: [],
    loading: false,
    root_field_id: '',
  }),

  computed: {
    ...mapGetters(['sitePath', 'centro_id']),

    value() {
      return this.props.value
    },
    
    rules() {
      // TODO: Multilang: Change hardcoded string
      return [(value) => !!value || !this.props.required || this.$vuetify.lang.translator('required_field')]
    },

    root_field_value() {
      return this.form_values[this.props.root_field_id];
    },
  },

  mounted() {
    this.items = this.props.items || []
  },

  methods: {
    validate() {
      // TODO: Show error message
      return !this.props.required || !!this.value
    },

    update_items(value) {
      if (!value) {
        this.update();
        this.items = [];
        return;
      }
      console.log('get_depending_select_choices',value,this.props.bp_reference,this.props.site_id,this.props.id,this.centro_id,this.current_unit)
      this.loading = true
      // Updates choices because reference value has changed
      console.log('DynamicSelectInput.update_items(', value, ')')
      QUnitWidgets.get_depending_select_choices(this.sitePath, {
        reference_value: value,
        bp_reference: this.props.bp_reference,
        site_id: this.props.site_id,
        field_id: this.props.id,
        centro_id:this.centro_id,
        current_qunit_id: this.current_unit ? this.current_unit.uid : "",
      })
        .then(
          function (data) {
            this.loading = false
            console.log(
              'DEBUGGING DynamicSelectInput.update_items() → ',
              data,
            )
            this.items = data.data
          }.bind(this),
        )
        .catch((err) => console.warn(err)) // DEBUG
    },

    error_state(ok) {
      this.valid = ok
    },

    update(value) {
      this.$emit('update',value);
    },
  },
  watch: {
    root_field_value() {
      this.update_items(this.root_field_value);
    }
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>
